import { GetterTree } from 'vuex';
import { GlobalState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<GlobalState, RootState> = {

  hasItemsInCart(state: GlobalState, getters) {
    return state.cart && state.cart.products && state.cart.products.length
  }
};
